export default __webpack_public_path__ + "static/media/meet-the-pets.d219ad1a.png";